export const isSuccessReponseCode = (code?: string | null) => {
  return code === '00' || code === '08' || code === '11'
}
